import React from 'react';

const ListRowData = ({ lineOne, lineTwoLeft, lineTwoRight }) => {
    return <React.Fragment>
        <div className="col">
            <p className="mb-0">
                <span className="contact-name">
                    {lineOne}
                </span>
            </p>
            {lineTwoLeft || lineTwoRight
                ?
                <div>
                    <span className="email d-inline-block mr-2">
                        {lineTwoLeft}
                    </span>
                    <span className="phone d-inline-block">
                        {lineTwoRight}
                    </span>
                </div>
                : null
            }

        </div>
    </React.Fragment>;
};

export default ListRowData;


// WEBPACK FOOTER //
// ./components/ListRowData/index.js